const SvgAi4 = (props) => (
  <>
    <path
      d="M96.21 5c14.89 0 27 12.11 27 27s-12.11 27-27 27-27-12.11-27-27 12.11-27 27-27m0-1c-15.46 0-28 12.54-28 28s12.54 28 28 28 28-12.54 28-28-12.54-28-28-28Z"
      fill={props.p50}
    />
    <path fill="none" stroke={props.p50} strokeMiterlimit={10} strokeWidth={1.05} d="M100.19 32h58.05" />
    <circle cx={160} cy={32} r={4} fill={props.p50} />
    <circle cx={96.21} cy={32} r={4} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <path
      d="M160 85.21c14.89 0 27 12.11 27 27s-12.11 27-27 27-27-12.11-27-27 12.11-27 27-27m0-1c-15.46 0-28 12.54-28 28s12.54 28 28 28 28-12.54 28-28-12.54-28-28-28Z"
      fill={props.p50}
    />
    <path fill="none" stroke={props.p50} strokeMiterlimit={10} strokeWidth={1.05} d="M160 115.94v59.3" />
    <circle cx={160} cy={176} r={4} fill={props.p50} />
    <circle cx={160} cy={112.21} r={4} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <path
      d="M159.79 213c14.89 0 27 12.11 27 27s-12.11 27-27 27-27-12.11-27-27 12.11-27 27-27m0-1c-15.46 0-28 12.54-28 28s12.54 28 28 28 28-12.54 28-28-12.54-28-28-28Z"
      fill={props.p50}
    />
    <path fill="none" stroke={props.p50} strokeMiterlimit={10} strokeWidth={1.05} d="M155.75 240H96.76" />
    <circle cx={96} cy={240} r={4} fill={props.p50} />
    <circle cx={159.79} cy={240} r={4} fill="none" stroke={props.p50} strokeMiterlimit={10} />
    <path
      d="M96 293.21c14.89 0 27 12.11 27 27s-12.11 27-27 27-27-12.11-27-27 12.11-27 27-27m0-1c-15.46 0-28 12.54-28 28s12.54 28 28 28 28-12.54 28-28-12.54-28-28-28Z"
      fill={props.p50}
    />
    <path fill="none" stroke={props.p50} strokeMiterlimit={10} strokeWidth={1.05} d="M96 324.19v59.05" />
    <circle cx={96} cy={384} r={4} fill={props.p50} />
    <circle cx={96} cy={320.21} r={4} fill="none" stroke={props.p50} strokeMiterlimit={10} />
  </>
);

export default SvgAi4;
